<template>
  <div id="v-date">
    <v-text-field
      ref="editor"
      :label="label"
      :rules="rules"
      readonly
      :dense="dense"
      required
      :value="setmodel.displayDate"
      @click="modalDate = true"
    >
      <v-icon slot="prepend-inner" color="primary" @click="modalDate = true">
        mdi-calendar
      </v-icon>
    </v-text-field>

    <v-dialog
      ref="dialogDate"
      v-model="modalDate"
      :return-value.sync="model"
      width="unset"
    >
      <v-date-picker v-model="dateModel" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modalDate = false"> Cancel </v-btn>
        <v-btn text color="primary" @click="confirmDate()"> OK </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "vdate",
  props: ["value", "label", "rules", "dense"],
  data() {
    return {
      modalDate: false,
      dateModel: null,
      displayDate: null,
      nameRules: [(v) => !!v || "Field is required"],
    };
  },
  mounted() {
    this.dateModel = this.setmodel.dateModel;
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(model) {
        console.log(model);
      },
    },
    setmodel() {
      var d = new Date();
      console.log(this.value);
      if (this.value != null) d = new Date(this.value);

      const dateModel = moment(d).format("YYYY-MM-DD");
      const displayDate = moment(d).format("DD-MMM-YYYY");

     return {
        dateModel: dateModel,
        displayDate: displayDate
      }
    },
  },
  methods: {
    confirmDate() {
      this.onUpdateDate();
      this.modalDate = false;
    },
    onUpdateDate() {
      if (!this.dateModel) return false;

      this.displayDate = moment(this.dateModel).format("DD-MMM-YYYY");

      this.$emit("input", this.dateModel);
    },
  },
};
</script>
